import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import MasterDetailsReport from '../../../../common/components/MasterDetailsReport';
import DespatchMonitoringReport from '../../common/components/DespatchMonitoringReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMonitoringReceptacleDetailsSelectors';

export function DespatchMonitoringReceptacleDetailsContainer(props) {
  return (
    <DespatchMonitoringReport
      reportId={ReportDefinitions.DESPATCH_MONITORING_RECEPTACLE_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
      masterDetailsReport={new MasterDetailsReport('predesMessage.despatchS8Id')}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

DespatchMonitoringReceptacleDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(DespatchMonitoringReceptacleDetailsContainer);

